import { render } from "./Map.vue?vue&type=template&id=0364cc54&scoped=true&ts=true"
import script from "./Map.vue?vue&type=script&lang=ts"
export * from "./Map.vue?vue&type=script&lang=ts"

import "./Map.vue?vue&type=style&index=0&id=0364cc54&scoped=true&lang=css"

import exportComponent from "C:\\Users\\wotruba\\IdeaProjects\\fungus_data_tool\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0364cc54"]])

export default __exports__